import { Link } from "react-router-dom";
import { categories, animeList } from "@/mocks/anime";

export default function Categories() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-end justify-between mb-8 md:mb-10">
          <div>
            <p className="text-sm text-primary-600 font-medium inline-flex items-center gap-2">
              <i className="ri-focus-3-line"></i>
              题材分类
            </p>
            <h2 className="mt-2 font-heading text-3xl md:text-4xl text-foreground-950">
              奇幻番剧，按题材直接找
            </h2>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {categories.map((c) => {
            const count = animeList.filter((a) => a.category === c.type).length;
            return (
              <Link
                key={c.type}
                to={`/category/${c.type}`}
                className="group relative rounded-2xl overflow-hidden h-72 md:h-80 block border border-background-200"
              >
                <img
                  src={c.image}
                  alt={`${c.name} 分类图片`}
                  className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/80 via-foreground-950/30 to-transparent"></div>
                <div className="absolute inset-x-0 bottom-0 p-5 md:p-6">
                  <div className="flex items-center justify-between">
                    <span className="w-11 h-11 rounded-xl bg-white/15 backdrop-blur text-white flex items-center justify-center text-xl">
                      <i className={c.icon}></i>
                    </span>
                    <span className="px-3 py-1 rounded-full bg-primary-500 text-white text-xs">
                      {count} 部收录
                    </span>
                  </div>
                  <h3 className="mt-4 font-heading text-2xl text-white">{c.name}</h3>
                  <p className="mt-1 text-sm text-accent-200">{c.tagline}</p>
                  <p className="mt-2 text-sm text-white/80 line-clamp-2">{c.desc}</p>
                  <span className="mt-3 inline-flex items-center gap-1 text-sm text-white group-hover:gap-2 transition-all">
                    查看分类 <i className="ri-arrow-right-line"></i>
                  </span>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}